<!-- <div class="portal-background"
     [ngClass]="{'home-background': isMobileDevice$ | async}">
  <div class="gradient">
    <div class="container">


      <h1 class="portal-title">Welcome to {{APP_TITLE_LONG}}</h1>
      <section *ngIf="!(isUserAuthenticated$ | async)"
               class="login-section get-started">
        <div class="actions login-notes ">
          <div [ngClass]="(isMobileDevice$ | async) ? 'mat-h2' : 'mat-h1'">
            <div class="pt-2 "> An account is required to login into our customer portal</div>
            <div class="pt-2"> To obtain a Login/info please send an email to: <a href="appInfoEmail">{{appInfoEmail}}
              </a></div>
            <div class="pt-2 "> Or select Sign Up below</div>
          </div>
        </div>
        <div *ngIf="isLoading$ | async"
             class="d-flex justify-content-center">
        </div>


      </section>

      <div class="row justify-content-center">
      </div>

    </div>
  </div>
</div> -->
<div class="block-section portal-background">

  <div class="block-content">
    <!-- <div
         class="align-items-center flex justify-content-center lg:px-8 md:px-6 px-4 py-8 surface-ground ng-star-inserted"> -->
    <div class="grid grid-nogutter surface-section text-800">
      <div class="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center justify-content-center">
        <section>
          <span class="block text-6xl font-bold mb-1">Welcome to {{APP_TITLE_LONG}}</span>
          <ng-container *ngIf="(isUserAuthenticated$ | async) === false">
            <div class="text-6xl text-primary font-bold mb-3">An account is required to login into our customer portal
            </div>
            <p class="mt-0 mb-4 text-700 line-height-3">To obtain a Login/info please send an email to: <a
                 href="appInfoEmail">{{appInfoEmail}}
              </a></p>

            <button pButton
                    pRipple
                    label="Login"
                    type="button"
                    class="mr-3 p-button-raised"
                    (click)="onLogin()"></button>
            <button pButton
                    pRipple
                    label="Pricing"
                    type="button"
                    class="mr-3 p-button-outlined"
                    (click)="onPricing()"></button>
            <button pButton
                    pRipple
                    label="Contact Us"
                    type="button"
                    class="p-button-outlined"
                    (click)="onContactUs()"></button>
          </ng-container>
        </section>
      </div>
      <!-- <div class="col-12 md:col-6 overflow-hidden">
      <img src="assets/images/blocks/hero/hero-1.png" alt="Image" class="md:ml-auto block md:h-full" style="clip-path: polygon(8% 0, 100% 0%, 100% 100%, 0 100%)">
  </div> -->
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
